"use client"

import { ChevronLeft, ChevronRight } from "lucide-react"
import { NavList } from "./NavList"

type OpenState = Record<string, boolean>

export function DesktopSidebar({
  pathname,
  isAdmin,
  isDeveloper,
  collapsed,
  setCollapsed,
  openSections,
  setOpenSections,
  openGroups,
  setOpenGroups,
}: {
  pathname: string
  isAdmin: boolean
  isDeveloper: boolean
  collapsed: boolean
  setCollapsed: (v: boolean) => void
  openSections: OpenState
  setOpenSections: (next: OpenState) => void
  openGroups: OpenState
  setOpenGroups: (next: OpenState) => void
}) {
  return (
    <aside
      className={`
        hidden lg:flex fixed left-0 top-16 bottom-0 flex-col bg-white/90 dark:bg-zinc-900/80 backdrop-blur-xl border-r border-zinc-200/70 dark:border-zinc-800 z-40
        transition-[width] duration-300 ease-in-out
        ${collapsed ? "w-[72px]" : "w-64"}
      `}
    >
      <div className="flex-1 overflow-y-auto custom-scrollbar py-5 px-3 space-y-2">
        <NavList
          pathname={pathname}
          isAdmin={isAdmin}
          isDeveloper={isDeveloper}
          collapsed={collapsed}
          openSections={openSections}
          setOpenSections={setOpenSections}
          openGroups={openGroups}
          setOpenGroups={setOpenGroups}
          variant="desktop"
        />
      </div>

      <div className="p-3 border-t border-gray-200 dark:border-zinc-800">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className={`
            w-full flex items-center gap-3 px-3 py-2 rounded-xl
            text-zinc-600 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800
            transition-colors group
            ${collapsed ? "justify-center" : ""}
          `}
        >
          {collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
          {!collapsed && <span className="text-sm font-medium">Zwiń menu</span>}
        </button>
      </div>
    </aside>
  )
}
